import { createTheme } from '@mui/material/styles';

// Main colors
const primary = {
  main: '#0068B9',
  light: '#29C6F3',
  dark: '#00803F',
  contrastText: '#fff'
};

const secondary = {
  main: '#17CF77',
  light: '#4CDFB0',
  dark: '#00803F',
  contrastText: '#fff'
};

// Custom gradients
const customGradients = {
  primary: 'linear-gradient(135deg, #0068B9 0%, #29C6F3 100%)',
  secondary: 'linear-gradient(135deg, #17CF77 0%, #00803F 100%)',
  accent: 'linear-gradient(135deg, #29C6F3 0%, #17CF77 100%)',
  glass: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.7) 100%)',
};

// Theme creation
const theme = createTheme({
  palette: {
    primary,
    secondary,
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    grey: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
    },
  },
  typography: {
    fontFamily: '"Inter var", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      background: customGradients.primary,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          textTransform: 'none',
          padding: '10px 24px',
          transition: 'all 0.3s ease-in-out',
        },
        contained: {
          background: customGradients.primary,
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 20px rgba(0, 104, 185, 0.3)',
          },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '16px',
            transition: 'all 0.3s ease-in-out',
            '&:hover': {
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
            },
            '&.Mui-focused': {
              boxShadow: '0 4px 15px rgba(0, 104, 185, 0.2)',
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: customGradients.glass,
          backdropFilter: 'blur(15px)',
          boxShadow: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
          transition: 'all 0.3s ease-in-out',
        },
        elevation1: {
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)',
        },
        elevation2: {
          boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
          },
        },
        filled: {
          background: customGradients.secondary,
          color: '#fff',
        },
      },
    },
  },
});

export { theme, customGradients };
